module.exports = __webpack_public_path__ + "img/logo.b18d3e5b.png";